import { Company } from './company.types'

export const CompanyInitValue: Company = {
  id: '',
  companyName: '',
  streetNumber: '',
  unitNumber: '',
  streetName: '',
  city: '',
  state: '',
  zipCode: '',
  notificationEmail: '',
  invoicePodEmail: '',
  accountPayableEmail: '',
  createdAt: '',
  modifiedAt: '',
  country: '',
  phoneNumber: '',
}
